// extracted by mini-css-extract-plugin
export default {"formField":"Vqa-z","error":"Wqa-z","disabled":"Xqa-z","fieldError":"Yqa-z","errorText":"Zqa-z","linkButton":"_qa-z","noCode":"ara-z","button":"bra-z","acknowledgment":"cra-z"};